import { makeStyles } from "@material-ui/core/styles";

import bgImage from '../assets/images/logarBackground.jpg';

const useStyles = makeStyles(theme => {

    return {
        waitingContent: {
            width: '100vw',
            height: '100vh',
            backgroundImage: `url(${bgImage})`,
            backgroundPosition: 'center',
            backgroundSize: 'auto 100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.up("md")]: {
                backgroundSize: '100% auto',
            }
        }
    }
});

export default useStyles;